let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kBnxw")).then(() => parcelRequire('3510C'));